import { type Permission, permissionSatisfies } from './permissions';

const EVALUATION_EXECUTE_PERMISSION = 'Evaluation Execute' as Permission;
const EVALUATION_READ_PERMISSION = 'Evaluation Read' as Permission;

export function hasEvaluationExecutePermission({
  permissions,
}: {
  permissions: readonly string[];
}): boolean {
  return permissions.some((userPermission) =>
    permissionSatisfies(
      userPermission as Permission,
      EVALUATION_EXECUTE_PERMISSION,
    ),
  );
}

export function hasEvaluationReadPermission({
  permissions,
}: {
  permissions: readonly string[];
}): boolean {
  return permissions.some(
    (userPermission) =>
      permissionSatisfies(
        userPermission as Permission,
        EVALUATION_READ_PERMISSION,
      ) ||
      permissionSatisfies(
        userPermission as Permission,
        EVALUATION_EXECUTE_PERMISSION,
      ),
  );
}
